import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Api } from '../api/api';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
/*
  Generated class for the PrizeGameProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PrizeGameProvider {
  constructor(public http: HttpClient, public api: Api) {}

  startGame(): Observable<any> {
    return this.api
      .post(
        'prizeGame/startGame?event=9484b8e4-6c9e-47e8-8044-6f68b6ccd6ba',
        {}
      )
      .map(res => {
        return res;
      });
  }

  stopGame(): Observable<any> {
    return this.api
      .post('prizeGame/endGame?event=9484b8e4-6c9e-47e8-8044-6f68b6ccd6ba', {})
      .map(res => {
        return res;
      });
  }

  isAdmin(): Observable<any> {
    return this.api.get('prizeGame/amIAdmin', {}).map(res => {
      return res;
    });
  }

  getGameList(eventUuid): Observable<any> {
    return this.api
      .get(`prizeGame/definitions?eventUuid=${eventUuid}`, {})
      .map(res => {
        return res;
      });
  }

  getGameWinnrList(eventUuid: string, gameId: string): Observable<any> {
    return this.api
      .get(`prizeGame/winners?event=${eventUuid}&prizeGameId=${gameId}`, {})
      .map(res => {
        return res;
      });
  }

  startPrizeGame(eventUuid: any, gameId: any): Observable<any> {
    return this.api.post(`prizeGame/startGame?event=${eventUuid}&prizeGameId=${gameId}`, {})
  }
  

  confirmWinner(event: any, prizeGameId: any, prizeId: any): Observable<any> {
      return this.api.post(`prizeGame/confirmWinner?event=${event}&prizeGameId=${prizeGameId}&prizeId=${prizeId}`, {})
  }

  skipWinner(event: any, prizeGameId: any, prizeId: any): Observable<any> {
      return this.api.post(`prizeGame/skipWinner?event=${event}&prizeGameId=${prizeGameId}&prizeId=${prizeId}`, {})
  }
}



// WEBPACK FOOTER //
// ./src/providers/prize-game/prize-game.ts